import { SvgIconProps } from "@material-ui/core/SvgIcon";
import CheckCircleTwoTone from "@material-ui/icons/CheckCircleTwoTone";
import OfflineBoltTwoTone from "@material-ui/icons/OfflineBoltTwoTone";
import SwapVerticalCircleTwoTone from "@material-ui/icons/SwapVerticalCircleTwoTone";
import { EnumUpdateRemaindStatus } from "../../../../server/routes/logUpdated/price/types";
import AccessTimeIcon from "@material-ui/icons/AccessTime";

const statuses: {
  [key in EnumUpdateRemaindStatus]: {
    Icon: React.VFC<SvgIconProps>;
    title: string;
    color: SvgIconProps["color"];
  };
} = {
  [EnumUpdateRemaindStatus.SUCCESS]: {
    Icon: CheckCircleTwoTone,
    color: "success",
    title: "Успешно",
  },
  [EnumUpdateRemaindStatus.ERROR]: {
    Icon: OfflineBoltTwoTone,
    color: "error",
    title: "Ошибка",
  },
  [EnumUpdateRemaindStatus.INVALID]: {
    Icon: SwapVerticalCircleTwoTone,
    color: "warning",
    title: "Невалидный",
  },
  [EnumUpdateRemaindStatus.NULL]: {
    Icon: AccessTimeIcon,
    color: "info",
    title: "Ожидание",
  },
};

export default statuses;
